// This file contains the German translations for the Recruta platform.
export default {
  header: {
    personal: 'Privat',
    business: 'Unternhemen',
    platform: 'Plattform',
    whyRecruta: 'Warum Recruta?',
    services: 'Leistungen',
    benefits: 'Vorteile',
    personalBenefits: 'Deine Vorteile',
    cases: 'Kundenbeispiele',
    useCases: 'Karriere neu gestalten',
    features: 'Plattform-Features',
    success: 'Erfolgsgeschichten',
    pricing: 'Gebühren',
    contactUs: 'Kontakt',
    clientPortal: 'Kundenportal',
    personalPortal: 'Dein Portal',
    back: 'Zurück',
    openMenu: 'Menü öffnen',
    closeMenu: 'Menü schließen',
  },
  footer: {
    services: 'Leistungen',
    company: 'Unternehmen',
    about: 'Über uns',
    impressum: 'Impressum',
    privacy: 'Datenschutz & AGB',
  },
  hero: {
    title1: 'Karrieren fördern,',
    title2: 'Übergänge unterstützen',
    description:
      'Professionelle Outplacement-Services, die Unternehmen bei der Gestaltung von Personalübergängen unterstützen und Mitarbeitern helfen, neue Chancen zu finden.',
    getStarted: 'Jetzt starten',
    learnMore: 'Mehr erfahren',
  },
  heroPersonal: {
    title1: 'Deine Karriere, dein Weg',
    title2: '- mit uns zum Erfolg!',
    description:
      'Ob Branchenwechsel, neue Perspektiven oder mehr Zeit für deine Familie – wir helfen dir, deine Ziele zu erreichen.',
    getStarted: 'Jetzt starten',
    learnMore: 'Mehr erfahren',
  },
  heroFeatures: {
    title: 'Finde deinen Traumjob',
    subtitle: 'Mit unserer fortschrittlichen AI-Plattform zum Erfolg!',
    description:
      'Bist du auf der Suche nach einem neuen Job oder einer beruflichen Umorientierung? ' 
      +'Unsere innovative Plattform verbindet fortschrittliche Technologie mit individuellem ' 
      +'Coaching, um dir den perfekten Job zu finden. Mit unserer einzigartigen Mischung aus '
      +'automatisierter Karriereberatung und personalisierten Diensten sind wir mehr als nur '
      +'eine Jobvermittlung. Wir sind dein Partner auf dem Weg zu deiner Traumkarriere.',
  },
  whyUs: {
    title: 'Warum Recruta?',
    subtitle:
      'Effiziente Vermittlung, Mehrwert und Unterstützung – für Unternehmen und Mitarbeiter.',
    efficiency: {
      title: 'Schneller ROI und nahtlose Unterstützung',
      points: [
        'Schnelle Vermittlung: Reduzieren Sie Kosten und Zeit bei Übergängen',
        'Kontinuierliche Unterstützung: Wir begleiten Unternehmen und Mitarbeiter bis zum Erfolg',
        'Bewährte Erfolgsbilanz: 90% erfolgreiche Vermittlungsquote',
      ],
    },
    dataProtection: {
      title: 'Datenschutz und Compliance',
      points: [
        'Sichere Datenverwaltung: Unser System erfüllt alle Datenschutzanforderungen',
        'Transparente Prozesse: Gewährleistung von Integrität bei jeder Vermittlung',
        'DSGVO-konform: Ihre Daten sind bei uns sicher',
      ],
    },
    network: {
      title: 'Umfangreiches Netzwerk',
      points: [
        'Verbindungen zu Arbeitgebern: Profitieren Sie von unserem Partnernetzwerk',
        'Branchenübergreifende Vermittlung: Flexible Lösungen für verschiedene Sektoren',
        'Globale Reichweite: Internationale Vermittlungsmöglichkeiten',
      ],
    },
  },
  useCases: {
    title: 'Gestalte deine berufliche Zukunft neu',
    subtitle:
      'Finde den Job, der wirklich zu dir passt – in deiner Branche, einer neuen oder mit mehr Flexibilität.',
    dissatisfied: {
      title: 'Bleib in deiner Branche – wir zeigen dir neue Wege',
      subtitle: 'Finde deine Berufung innerhalb deiner Branche',
      description: 'Fühlst du dich in deinem aktuellen Job unerfüllt, aber liebst die Branche, in der du tätig bist? Unsere Plattform hilft dir, eine neue Position zu finden, die besser zu deinen Fähigkeiten und Leidenschaften passt. Mit unserer automatisierten Karriereberatung erfassen wir deine Interessen und Fähigkeiten genau und zeigen dir alternative Karrierewege in deiner Branche auf. Nutze unsere maßgeschneiderten Bewerbungstools und das Videointerview-Training, um dich optimal auf deine nächste berufliche Herausforderung vorzubereiten. Es ist Zeit für einen beruflichen Neustart, ohne deine gewohnte Branche verlassen zu müssen.',
    },
    change: {
      title: 'Starte neu durch, mit einem Plan, der zu dir passt',
      subtitle: 'Gestalte deinen Karrierewechsel mit Vertrauen',
      description: 'Bist du bereit für eine völlig neue berufliche Herausforderung in einer anderen Branche? Unser Team unterstützt dich beim Neuaufbau deines Karriereplans, von der Neubewertung deiner Fähigkeiten bis hin zur Entdeckung neuer beruflicher Möglichkeiten. Mit Zugang zu umfangreichen E-Learning-Kursen und spezifischen Umschulungsprogrammen bereiten wir dich auf den Eintritt in eine neue Branche vor. Unser KI-gestütztes Job-Matching-System sorgt dafür, dass du Stellen findest, die nicht nur neu sind, sondern auch zu deinen neu entwickelten Fähigkeiten passen. Starte mutig in ein neues Berufsfeld mit unserer professionellen Unterstützung.',
    },
    flexible: {
      title: 'Finde Arbeitgeber, die dir flexible Lösungen bieten',
      subtitle: 'Finde einen Job, der deine Work-Life-Balance respektiert',
      description: 'Ist es an der Zeit, einen Job zu finden, der dir mehr Flexibilität bietet, um Zeit mit deiner Familie zu verbringen? Wir helfen dir, Arbeitgeber zu finden, die Work-Life-Balance nicht nur unterstützen, sondern fördern. Mit unserer Plattform kannst du gezielt nach Unternehmen suchen, die flexible Arbeitszeiten, Homeoffice-Optionen und eine familienfreundliche Unternehmenskultur bieten. Nutze unsere fortschrittlichen Tools und Ressourcen, um einen Arbeitsplatz zu finden, der deinen Bedürfnissen nach mehr Familienzeit gerecht wird, ohne deine beruflichen Ziele zu kompromittieren.',
    },
  },
  personalBenefits: {
    title: 'Deine Vorteile mit Recruta',
    subtitle:
      'Erfolgreich neu durchstarten – mit den passenden Tools und fundierter Beratung.',
    ai: {
      title: 'KI-gestützte Berufsberatung',
      description: 'Entdecke deine beruflichen Stärken und finde heraus, welche Positionen wirklich zu dir passen – auf Basis deiner Fähigkeiten und Interessen.',
    },
    help: {
      title: 'Individuelle Bewerbungshilfen',
      description: 'Erstelle einen professionellen Lebenslauf und profitiere von maßgeschneidertem Feedback und KI-gestützten Optimierungen.',
    },
    match: {
      title: 'Intelligentes Job-Matching',
      description: 'Wir zeigen dir Stellen, die zu deinem Profil passen – in deiner aktuellen Branche oder einer neuen.',
    },
    training: {
      title: 'Weiterbildung & berufliches Wachstum',
      description: 'Bereite dich gezielt auf deinen nächsten Karriereschritt vor – mit Online-Kursen, Zertifikaten und Weiterbildungen.',
    },
  },
  platformFeatures: {
    title: 'Unsere Plattform-Features',
    subtitle:
      'Dein Weg zu neuen Chancen – mit KI, Strategie und starken Netzwerken!',
    generator: {
      title: 'Karrierepfad-Generator',
      description: 'Dein maßgeschneiderter Weg zu neuen Chancen.',
    },
    help: {
      title: 'KI-gestützte Bewerbungshilfen',
      description: 'Optimiere deinen Lebenslauf – automatisiert und effektiv.',
    },
    network: {
      title: 'Netzwerk-Zugänge',
      description: 'Profitiere von exklusiven Partnerschaften und Kontakten.',
    },
  },
  features: {
    carreer_coaching: {
      title: 'Automatisierte Karriereberatung',
      subtitle: 'Dein persönlicher Karriere-Navigator',
      description:
        'Starte mit einem Kennenlernen-Interview, das deine aktuelle Situation '
        +'und beruflichen Wünsche genau erfasst. Unsere KI-Technologie analysiert '
        +'deine Fähigkeiten und eröffnet dir realistische Jobchancen basierend auf '
        +'aktuellen Markttrends. Durch die Erstellung eines maßgeschneiderten Karrierepfads, '
        +'der genau auf deine Kompetenzen abgestimmt ist, erhältst du klare Richtlinien und '
        +'Ziele für deinen beruflichen Fortschritt.',
    },
    tools: {
      title: 'Bewerbungstools & Coaching',
      subtitle: 'Optimiere deine Bewerbungsunterlagen',
      description:
        'Nutze unsere professionell gestalteten Lebenslauf- und Anschreibenvorlagen, die du '
        +'individuell an deine Bedürfnisse anpassen kannst. Mit unserem KI-gestützten CV-Scoring '
        +'und Optimierungstools stellen wir sicher, dass dein Lebenslauf die Aufmerksamkeit '
        +'erhält, die er verdient. Außerdem bieten wir Videointerview-Trainings mit direktem '
        +'KI-Feedback, um deine Interviewfähigkeiten signifikant zu verbessern.',
    },
    job_matching: {
      title: 'Job-Matching & Netzwerk',
      subtitle: 'Zugang zu exklusiven Stellenangeboten',
      description:
        'Profitiere von einem KI-basierten Job-Matching, das dir passende Stellen vorschlägt, '+
        'die auf deinem Profil und deinen Präferenzen basieren. Unsere Plattform ist direkt mit '+
        'einem exklusiven Pool an Partnerunternehmen und führenden Jobportalen wie LinkedIn, Indeed, '+
        'und StepStone vernetzt, was dir Zugang zu einer Vielzahl von Möglichkeiten bietet.',
    },
    upskilling: {
      title: 'Weiterbildung & Upskilling',
      subtitle: 'Bleibe wettbewerbsfähig',
      description:
        'Erhalte Zugang zu führenden E-Learning-Plattformen wie Udemy und Coursera und speziellen '+
        'Umschulungsprogrammen, die dich für gefragte Branchen qualifizieren. Unser Ziel ist es, dir '+
        'nicht nur einen Job zu finden, sondern dir auch die Fähigkeiten und das Wissen zu vermitteln, '+
        'um auf dem Arbeitsmarkt erfolgreich zu sein.',
    },
    digital: {
      title: 'Digitale Transfergesellschaft',
      subtitle: 'Unterstützung auf jedem Schritt des Weges',
      description:
        'Unser Team aus erfahrenen Karriere-Coaches und Psychologen steht dir zur Seite, um den Übergang '+
        'in eine neue berufliche Phase so reibungslos wie möglich zu gestalten. Von der psychologischen '+
        'Beratung bis zur praktischen Unterstützung bei der Jobsuche – wir sind hier, um dir zu helfen.',
    },
    benefits: {
      title: 'Nutze die Vorteile unserer Plattform',
      description:
        'Als Teilnehmer unserer Plattform hast du Zugriff auf fortschrittliche Tools und Ressourcen, die '+
        'dir helfen, deinen Weg in einem dynamischen Arbeitsmarkt zu navigieren. Mit unserer Unterstützung '+
        'erkennst du neue Jobchancen schneller und effizienter und kannst so den nächsten Schritt in deiner '+
        'Karriere planen und umsetzen.',
    },
    future: {
      title: 'Bist du bereit, deine Karriere voranzutreiben?',
      description:
        'Kontaktiere uns heute, um mehr über unsere Dienstleistungen zu erfahren und wie wir dich auf deinem '+
        'Weg zu einer erfüllenden beruflichen Zukunft unterstützen können. Unsere Outplacement-Plattform ist '+
        'dein Schlüssel zu neuen beruflichen Möglichkeiten und einem erfolgreichen Karriereweg.',
    },
  },
  successStories: {
    title: 'So haben wir Karrieren verändert',
    subtitle:
      'Echte Geschichten, echte Erfolge – lass dich inspirieren!',
    prevButton: 'Zurück',
    nextButton: 'Weiter',
    quote1: 'Dank Recruta habe ich endlich eine Stelle gefunden, die mich wirklich erfüllt.',
    quote2: 'Der Branchenwechsel war einfacher, als ich dachte – ich bin begeistert!',
    quote3: 'Recruta hat meinen Traumjob im Marketing möglich gemacht – danke für die tolle Unterstützung!',
    quote4: 'Ich hätte nie gedacht, dass ein Jobwechsel so reibungslos laufen kann. Top Service!',
    quote5: 'Recruta hat mir nicht nur einen Job verschafft, sondern auch mein Selbstvertrauen gestärkt.',
    quote6: 'Vom Erstgespräch bis zur Vertragsunterzeichnung – alles lief professionell und persönlich ab.',
    quote7: 'Ich war skeptisch, aber Recruta hat mich wirklich überrascht. Jetzt habe ich meinen Traumjob!',
    quote8: 'Die Karriereberatung war auf den Punkt. Ich fühle mich endlich beruflich angekommen.',
    quote9: 'Ich bin begeistert, wie schnell alles ging. Vielen Dank an das tolle Team von Recruta!',
    quote10: 'Recruta hat mir geholfen, meine Berufung zu finden – besser geht\'s nicht!',
    quote11: 'Die Unterstützung war individuell und empathisch – ich fühlte mich immer gut aufgehoben.',
    quote12: 'Einfach, schnell und effektiv. Recruta macht’s möglich!',
    quote13: 'Ich hätte nie gedacht, dass ein Wechsel in eine neue Branche so leicht sein kann.',
    quote14: 'Recruta hat meine Fähigkeiten erkannt und mir den passenden Job vermittelt – klasse!',
    quote15: 'Professionell, freundlich und sehr engagiert. Absolute Empfehlung!',
    quote16: 'Endlich ein Job, bei dem ich mich weiterentwickeln kann. Danke, Recruta!',
    quote17: 'Die persönliche Beratung war top – ich fühlte mich wirklich gesehen.',
    quote18: 'Ich bin sehr dankbar für die kompetente Begleitung durch Recruta.',
    quote19: 'Recruta hat mir die Tür zu einer neuen Karriere geöffnet. Einfach großartig!',
    quote20: 'Ich hätte ohne Recruta nicht den Mut gefunden, mich beruflich neu zu orientieren.',
    quote21: 'Super Kommunikation und tolle Jobangebote – ich bin glücklich!',
    quote22: 'Recruta war der Wendepunkt in meiner Karriere. Vielen Dank!',
    quote23: 'Ich war auf der Suche nach mehr Sinn im Job – Recruta hat ihn mir gebracht.',
    quote24: 'Vom Lebenslauf-Check bis zum Bewerbungsgespräch – ich wurde top vorbereitet.',
    quote25: 'Ich hätte nie gedacht, dass Jobsuche so entspannt sein kann!',
    quote26: 'Recruta hat mir nicht nur einen Job vermittelt, sondern auch neue Perspektiven gezeigt.',
    quote27: 'Ich bin überglücklich – Recruta hat mir den Einstieg in eine neue Branche ermöglicht.',
    quote28: 'Kompetent, schnell, zuverlässig – besser kann ein Service nicht sein.',
    quote29: 'Ein echter Karriereschub – danke, Recruta!',
    quote30: 'Ich fühle mich beruflich angekommen. Recruta hat perfekt vermittelt.',
    quote31: 'Endlich ein Job, der zu mir passt. Vielen Dank für die tolle Unterstützung!',
    quote32: 'Ich bin begeistert, wie einfach der Prozess mit Recruta war.',
    quote33: 'Ohne Recruta hätte ich diesen Karrieresprung nicht geschafft!',
    quote34: 'Top Betreuung, schnelle Vermittlung, super Job!',
    quote35: 'Ich bin froh, dass ich auf Recruta gesetzt habe. Es hat sich gelohnt!',
    quote36: 'Die Beratung war individuell und ehrlich – genau das, was ich gesucht habe.',
    quote37: 'Mein neuer Job passt wie angegossen – danke, Recruta!',
    quote38: 'Recruta hat meine Karriere auf ein neues Level gebracht.',
    quote39: 'Die perfekte Mischung aus Professionalität und Menschlichkeit.',
    quote40: 'Ich hätte nicht gedacht, dass ich so schnell etwas Neues finde!',
    quote41: 'Recruta war mein Glücksgriff – klare Empfehlung!',
    quote42: 'Endlich mache ich das, was mir wirklich Spaß macht!',
    quote43: 'Recruta hat mich motiviert, mich neu zu orientieren – und es hat sich gelohnt.',
    quote44: 'Ich war schon fast verzweifelt – dann kam Recruta. Jetzt bin ich happy im neuen Job!',
    quote45: 'Schnell, effizient und immer erreichbar – super Service.',
    quote46: 'Ein ganz neues Lebensgefühl – danke an das Recruta-Team!',
    quote47: 'Einfach nur Danke! Ich liebe meinen neuen Arbeitsplatz.',
    quote48: 'Recruta hat mich ernst genommen und genau das gefunden, was ich gesucht habe.',
    quote49: 'Von Anfang an ein gutes Gefühl – und jetzt der perfekte Job.',
    quote50: 'Die persönliche Betreuung hat den Unterschied gemacht. Vielen Dank!',
    quote51: 'Mit Recruta hab ich nicht nur einen Job gefunden, sondern auch neue Motivation.',
    quote52: 'Das war der beste Karriereschritt meines Lebens – danke, Recruta!',
  },
  comparison: {
    title: 'Die Vorteile von Recruta',
    withoutRecruta: {
      title: 'Ohne Recruta',
      points: [
        'Talentabwanderung: Freigesetzte Mitarbeiter haben keine klaren Perspektiven',
        'Hohe Kosten: Langwierige Kündigungen und rechtliche Auseinandersetzungen',
        'Fehlende Unterstützung: Mitarbeiter fühlen sich allein gelassen',
        'Zeitaufwendig: HR-Teams verbringen wertvolle Zeit mit Verwaltung',
      ],
    },
    withRecruta: {
      title: 'Mit Recruta',
      points: [
        'Reibungslose Übergänge: Mitarbeiter finden schnell neue Positionen',
        'Kosteneffizienz: Leistungsbasierte Gebühren und klare Prozesse',
        'Motivierte Belegschaft: Zeigen Sie Verantwortung und Fürsorge',
        'Datengesteuert: Transparente Einblicke für HR-Strategien',
      ],
    },
  },
  services: {
    title: 'Unsere Leistungen',
    subtitle: 'Umfassende Outplacement-Lösungen nach Ihren Bedürfnissen',
    items: {
      careerCoaching: {
        title: 'Karriere-Coaching',
        description:
          'Individuelle Beratung zur Entdeckung neuer Karriere\u00ADmöglichkeiten und -wege.',
      },
      jobPlacement: {
        title: 'Arbeitsvermittlung',
        description:
          'Direkte Vermittlung durch unser umfangreiches Netzwerk von Partner\u00ADunternehmen.',
      },
      skillsDevelopment: {
        title: 'Kompetenzentwicklung',
        description:
          'Workshops und Schulungs\u00ADprogramme zur Steigerung der Beschäftigungs\u00ADfähigkeit.',
      },
      supportPrograms: {
        title: 'Unterstützungsprogramme',
        description:
          'Umfassende Unterstützung bei Lebenslauf, Bewerbungs\u00ADvorbereitung und Networking.',
      },
    },
    buttonMore: 'Weitere Informationen',
  },
  benefits: {
    title: 'Vorteile für Unternehmen',
    subtitle: 'Warum Sie sich für Recruta entscheiden sollten',
    points: [
      'Schützen Sie Ihren Ruf und zeigen Sie unternehmerische Verantwortung',
      'Minimieren Sie rechtliche Risiken durch professionelles Übergangsmanagement',
      'Unterstützen Sie das Wohlbefinden der Mitarbeiter während des Übergangs',
      'Erhalten Sie die Teammoral und zeigen Sie Fürsorge',
    ],
  },
  process: {
    title: 'Unser Prozess',
    subtitle: 'Ein strukturierter Ansatz für den Karriereübergang',
    steps: {
      assessment: {
        title: 'Bewertung',
        description: 'Evaluierung aktueller Fähigkeiten und Karriereziele',
      },
      planning: {
        title: 'Planung',
        description: 'Entwicklung einer personalisierten Übergangsstrategie',
      },
      development: {
        title: 'Entwicklung',
        description: 'Kompetenzsteigerung und Training',
      },
      placement: {
        title: 'Vermittlung',
        description: 'Jobsuche und erfolgreicher Übergang',
      },
    },
    additionalInfo: {
      title: 'Warum unser Prozess funktioniert',
      point1:
        'Strukturierter Ansatz stellt sicher, dass kein Schritt übersehen wird',
      point2: 'Persönliche Unterstützung in jeder Phase',
      successRate: 'Erfolgsquote bei Karriereübergängen',
    },
  },
  cases_text: {
    title: 'Erfolgsgeschichten',
    subtitle: 'Wie wir Unternehmen aller Größen bei Übergängen unterstützen',
    categories: {
      small: 'Kleine Unternehmen',
      medium: 'Mittelständische Unternehmen',
      large: 'Großunternehmen',
    },
    employees: 'Mitarbeiter',
    challenge: 'Herausforderung',
    solution: 'Lösung',
    results: 'Ergebnisse',
    placementRate: 'Vermittlungsquote',
    timeToPlacement: 'Wochen bis zur Vermittlung',
    satisfactionScore: 'Zufriedenheit',
  },
  customer_cases: {
    case1: {
      industry: 'Software-Entwicklung',
      challenge:
        'Aufgrund von Finanzierungsproblemen musste die Belegschaft um 33 % reduziert werden, wobei die Moral des Teams aufrechterhalten und die betroffenen Mitarbeiter unterstützt werden mussten.',
      solution:
        'Einführung eines personalisierten Programms für den beruflichen Übergang mit Schwerpunkt auf der Vermittlung von Arbeitsplätzen im Technologiesektor und Start-up-Möglichkeiten.',
    },
    case2: {
      industry: 'Nachhaltiger Einzelhandel',
      challenge:
        'Die Konsolidierung der Filiale erforderte die Übernahme von 5 Mitarbeitern, wobei der Ruf der Marke in der örtlichen Bevölkerung erhalten blieb.',
      solution:
        'Entwicklung eines gezielten Vermittlungsprogramms für den Einzelhandelssektor mit zusätzlichen Schulungen für nachhaltige Geschäftspraktiken.',
    },
    case3: {
      industry: 'Technologie im Gesundheitswesen',
      challenge:
        'Die Umstrukturierung der Abteilung betraf 25 Mitarbeiter in technischen und administrativen Funktionen.',
      solution:
        'Erstellung eines umfassenden Übergangsprogramms mit Schwerpunkt auf dem Gesundheitssektor und Möglichkeiten zur Weiterqualifizierung.',
    },
    case4: {
      industry: 'Automobilindustrie',
      challenge:
        'Von der Automatisierung der Produktion waren 40 Mitarbeiter betroffen, die erhebliche berufliche Veränderungen vornehmen mussten.',
      solution:
        'Umsetzung eines gemischten Ansatzes aus Umschulung und Outplacement mit Schwerpunkt auf modernen Fertigungskompetenzen.',
    },
    case5: {
      industry: 'Bankwesen und Finanzen',
      challenge:
        'Die Initiative zur digitalen Transformation betraf 200 Mitarbeiter aus verschiedenen Abteilungen und Standorten.',
      solution:
        'Umfassendes Outplacement-Programm mit individuellem Coaching und Fintech-Schulungsmöglichkeiten.',
    },
    case6: {
      industry: 'Industrielle Fertigung',
      challenge:
        'Die Modernisierung des Werks betraf 150 Beschäftigte, die erhebliche berufliche Veränderungen vornehmen mussten.',
      solution:
        'Mehrstufiges Übergangsprogramm mit Kompetenzbewertung, Schulung und Vermittlungsdiensten.',
    },
  },
  resources: {
    title: 'Ressourcen',
    subtitle: 'Einblicke und Leitfäden für erfolgreiche Übergänge',
    viewAll: 'Alle Ressourcen anzeigen',
    type: {
      blogpost: 'Blog-Beitrag',
      whitepaper: 'Whitepaper',
      webinar: 'Webinar',
    },
    titles: {
      blogpost: 'Wirksame Outplacement-Strategien im Jahr 2024',
      whitepaper: 'Der ROI von professionellen Outplacement-Dienstleistungen',
      webinar: 'Digitale Transformation und Karriereübergänge',
    },
    descriptions: {
      blogpost:
        'Informieren Sie sich über die neuesten Trends und bewährten Praktiken bei Outplacement-Dienstleistungen.',
      whitepaper:
        'Eine umfassende Analyse der finanziellen Vorteile von Outplacement-Programmen.',
      webinar:
        'Expertenwissen zum Umgang mit beruflichen Veränderungen im digitalen Zeitalter.',
    },
    date: {
      blogpost: '15.03.2024',
      whitepaper: '28.02.2024',
      webinar: '20.03.2024',
    },
  },
  contact: {
    title: 'Kontakt',
    subtitle:
      'Lassen Sie uns besprechen, wie wir Ihrem Unternehmen helfen können',
      subtitlePersonal:
        'Lassen Sie uns besprechen, wie wir Ihnen helfen können',
    form: {
      name: 'Name',
      email: 'E-Mail',
      message: 'Nachricht',
      send: 'Nachricht senden',
      sending: 'Senden...',
      schedule: 'Termin vereinbaren',
      success: 'Vielen Dank für Ihre Nachricht! Wir werden uns in Kürze bei Ihnen melden.',
      error_sending: 'Es gab ein Problem beim Senden Ihrer Nachricht. Bitte versuchen Sie es erneut.',
      error: {
        name: 'Bitte geben Sie Ihren Namen ein',
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        message: 'Bitte geben Sie eine Nachricht ein',
      },

    },
    info: {
      email: 'E-Mail',
      phone: 'Telefon',
      location: 'Standort',
    },
    booking: {
      name: 'Ihr Name',
      email:'Bitte geben Sie Ihre E-Mail-Adresse an'
    },
  },
  auth: {
    login: {
      title: 'Anmelden',
      email: 'E-Mail-Adresse',
      password: 'Passwort',
      emailRequired: 'E-Mail ist erforderlich',
      passwordRequired: 'Passwort ist erforderlich',
      submit: 'Anmelden',
    },
  },
  dashboard: {
    welcome: 'Willkommen, {company}',
    stats: {
      title: 'Übersicht',
      totalEmployees: 'Gesamtanzahl Mitarbeiter',
      placementRate: 'Vermittlungsquote',
      avgPlacementTime: 'Durchschn. Vermittlungszeit',
      satisfaction: 'Zufriedenheitsrate',
    },
    employees: {
      title: 'Mitarbeiterübergänge',
      subtitle: 'Verfolgen Sie den Fortschritt der Mitarbeiter im Übergang',
      name: 'Name',
      position: 'Position',
      status: 'Status',
      startDate: 'Startdatum',
      progress: 'Fortschritt',
    },
  },
  text: {
    readtime: 'Minuten Lesezeit',
    duration: 'Minuten',
  },
  pricing: {
    title: 'Transparente Preisgestaltung',
    subtitle: 'Wählen Sie das richtige Paket für Ihr Unternehmen',
    packages: {
      package1: {
        name: 'Basis-Paket',
        price: '2000',
        description: 'Wesentlicher Support für kleine Teams',
        features: {
          feat1: 'Bewertung der beruflichen Laufbahn',
          feat2: 'Überprüfung des Lebenslaufs',
          feat3: 'Strategie für die Stellensuche',
          feat4: 'Zugang zu Online-Ressourcen',
          feat5: '3 Monate Support',
        },
      },
      package2: {
        name: 'Premium-Paket',
        price: '4000',
        description: 'Umfassender Support beim Übergang',
        features: {
          feat1: 'Alle Grundfunktionen',
          feat2: 'Persönlicher Karriere-Coach',
          feat3: 'Vorbereitung auf das Vorstellungsgespräch',
          feat4: 'Workshops zur Vernetzung',
          feat5: 'Bewertung der Fähigkeiten',
          feat6: '6 Monate Support',
        },
      },
      package3: {
        name: 'Führungskräfte-Paket',
        price: '10000',
        description: 'Persönlicher Support für leitende Positionen',
        features: {
          feat1: 'Alle Premium-Funktionen',
          feat2: '1:1 Coaching für Führungskräfte',
          feat3: 'Entwicklung einer persönlichen Marke',
          feat4: 'Zugang zu Netzwerken für Führungskräfte',
          feat5: 'Analyse der Marktchancen',
          feat6: '12 Monate Support',
        },
      },
    },
    priceNote: 'pro Mitarbeiter',
    popular: 'Besonders beliebt',
    button: 'Jetzt starten',
    footer1: 'Sie benötigen eine individuelle Lösung?',
    footer2: 'Kontaktieren Sie uns',
    footer3: 'für die Preisgestaltung für ihr Unternehmen.',
  },
  about: {
    title: 'Über Recruta',
    subtitle: 'Karrieren fördern, Übergänge unterstützen',
    mission: 'Unsere Mission',
    mission_description:
      'Wir von Recruta haben es uns zur Aufgabe gemacht, Unternehmen und ihre Mitarbeiter bei der erfolgreichen Bewältigung beruflicher Übergänge zu unterstützen. Unser Ziel ist es, umfassende Outplacement-Dienstleistungen anzubieten, die einen reibungslosen Übergang gewährleisten und dabei Würde und Professionalität während des gesamten Prozesses wahren.',
    vision: 'Unsere Vision',
    vision_description:
      'Wir stellen uns eine Zukunft vor, in der Karriereübergänge nicht als Rückschläge, sondern als Chancen für Weiterentwicklung gesehen werden. Durch unseren innovativen Ansatz und unser Engagement für Spitzenleistungen wollen wir der führende Partner für Unternehmen bei der Bewältigung von Personalübergängen sein.',
    values_title: 'Unsere Werte',
    values: {
      value1: {
        title: 'Die Menschen im Mittelpunkt',
        description:
          'Das Wohlbefinden und der Erfolg jedes Einzelnen, mit dem wir zusammenarbeiten, stehen für uns an erster Stelle.',
      },
      value2: {
        title: 'Exzellenz',
        description:
          'Wir streben in jedem Aspekt unserer Dienstleistungen nach Spitzenleistungen.',
      },
      value3: {
        title: 'Integrität',
        description:
          'Wir halten die höchsten Standards der Berufsethik und Transparenz ein.',
      },
      value4: {
        title: 'Innovation',
        description:
          'Wir entwickeln unsere Dienstleistungen ständig weiter, um den sich ändernden Marktanforderungen gerecht zu werden.',
      },
    },
  },
  privacy: {
    title: 'Datenschutzerklärung und Nutzungsbedingungen der Recruta GmbH',
    valid: 'Gültig ab April 2025',
    agbTitle: 'Allgemeine Nutzungsbedingungen für Recruta-Dienste',
    scope: 'Geltungsbereich',
    scopeDescription:
      'Diese allgemeinen Nutzungsbedingungen (AGB) gelten für die Nutzung der Plattformen, Webanwendungen, mobilen Applikationen und weiteren Dienste, die von der Recruta GmbH, Von-Vincke-Str. 5–7, 48143 Münster, Deutschland, bereitgestellt werden.',
    subject: 'Vertragsgegenstand',
    subjectDescription:
      'Recruta bietet digitale Lösungen und Services rund um Recruiting, Talentmanagement, Bewerberverwaltung und Unternehmensberatung. Nutzer dieser Dienste erkennen mit ihrer Registrierung bzw. Nutzung diese AGB an.',
    contract: 'Vertragsschluss und Nutzung',
    contractDescription:
      'Die Nutzung setzt eine Registrierung voraus. Die Registrierung ist nur voll geschäftsfähigen natürlichen oder juristischen Personen gestattet. Nutzer verpflichten sich, bei der Anmeldung wahrheitsgemäße Angaben zu machen.',
    services: 'Leistungsumfang',
    servicesDescription:
      'Recruta stellt verschiedene Funktionen bereit (u. a. Bewerbermanagement, Kommunikationstools, Karriereplattformen). Ein Anspruch auf die dauerhafte Bereitstellung einzelner Funktionen besteht nicht. Recruta ist berechtigt, Inhalte und Funktionen jederzeit zu ändern, zu ergänzen oder zu löschen.',
    obligations: 'Pflichten der Nutzer',
    obligationsDescription:
      'Nutzer verpflichten sich insbesondere:',
    obligationslist: [
      'keine rechtswidrigen Inhalte über die Plattform zu verbreiten,',
      'Zugangsdaten geheim zu halten,',
      'die Plattform nicht missbräuchlich zu nutzen oder technische Abläufe zu manipulieren,',
      'Schutzrechte Dritter zu beachten.',
    ],
    fees: 'Vergütung',
    feesDescription:
      'Sofern kostenpflichtige Leistungen gebucht werden, erfolgt die Abrechnung nach den jeweils aktuellen Preisangaben. Rechnungen sind sofort fällig, sofern nicht anders vereinbart.',
    rights: 'Nutzungsrechte / Inhalte Dritter',
    rightsDescription:
      'Recruta erhält das einfache, nicht-exklusive, zeitlich und räumlich unbegrenzte Nutzungsrecht an allen durch die Nutzer bereitgestellten Inhalten (z. B. Stellenanzeigen), um diese für die Vertragsdurchführung zu verwenden. Nutzer dürfen nur Inhalte einstellen, an denen sie die erforderlichen Rechte besitzen.',
    liability: 'Haftung',
    liabilityDescription:
      'Recruta haftet nur für Schäden, die auf einer grob fahrlässigen oder vorsätzlichen Pflichtverletzung beruhen. Für Datenverluste haftet Recruta nur, wenn der Nutzer eine regelmäßige, dem Risiko angemessene Datensicherung durchgeführt hat.',
    termination: 'Vertragsdauer und Kündigung',
    terminationDescription:
      'Verträge über kostenlose Basisnutzung können jederzeit beendet werden. Für kostenpflichtige Leistungen gelten die im Vertrag vereinbarten Laufzeiten und Kündigungsfristen. Das Recht zur außerordentlichen Kündigung bleibt unberührt.',
    dataProtection: 'Datenschutz',
    dataProtectionDescription:
      'Unsere Datenschutzpraxis richtet sich nach der EU-Datenschutz-Grundverordnung (DSGVO). Die Datenschutzerklärung ist unter ',
    dataProtectionDescription2: ' abrufbar.',
    processing: 'Auftragsverarbeitung',
    processingDescription:
      'Sofern Recruta im Auftrag personenbezogene Daten verarbeitet oder Dritte damit beauftragt, erfolgt dies auf Grundlage einer schriftlichen Vereinbarung gemäß Art. 28 DSGVO. Alle Unterauftragnehmer (z. B. Hosting-Anbieter, E-Mail-Dienstleister, Tracking-Tools) wurden vertraglich zur Einhaltung der DSGVO verpflichtet.',
    cookies: 'Cookies und Consent Management',
    cookiesDescription:
      'Beim Besuch der Plattform wird ein DSGVO-konformes Cookie-Consent-Tool eingesetzt. Dort können Nutzer ihre Einwilligung zu Cookies und Tracking-Tools individuell verwalten und jederzeit widerrufen. Eine Protokollierung der Einwilligungen erfolgt revisionssicher.',
    changes: 'Änderungen der Nutzungsbedingungen',
    changesDescription:
      'Recruta behält sich das Recht vor, diese Bedingungen mit Wirkung für die Zukunft zu ändern. Über Änderungen werden die Nutzer rechtzeitig informiert. Die weitere Nutzung nach Inkrafttreten gilt als Zustimmung.',
    finalProvisions: 'Schlussbestimmungen',
    finalProvisionsDescription:
      'Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Gerichtsstand für alle Streitigkeiten aus diesem Vertrag ist – sofern gesetzlich zulässig – Münster.',
    finalProvisionsDescription2:
      'Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam sein oder werden, so bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.',
    privacyPolicy: 'Datenschutzerklärung',
    privacyPolicyDescription: 'Wir legen größten Wert auf den Schutz Ihrer Daten und die Wahrung Ihrer Privatsphäre. Deshalb verarbeiten wir personenbezogene Daten ausschließlich im Einklang mit den geltenden Datenschutzgesetzen.',
    responsible: 'Verantwortlicher',
    responsibletext1: 'Recruta GmbH',
    responsibletext2: 'HRB 22437 | Amtsgericht Münster',
    responsibletext3: 'Geschäftsführer: Gabriel Morais',
    responsibletext4: 'Von-Vincke-Str. 5–7, 48143 Münster Deutschland',
    responsibletext5: 'Telefon: +49 (0) 251 748 497 41',
    responsibletext6: 'Fax: +49 (0) 322 264 129 17',
    responsibletext7: 'E-Mail: ',
    protectionOfficer: 'Datenschutzbeauftragter',
    protectionOfficerText1: 'E-Mail: ',
    purposes: 'Zwecke und Rechtsgrundlagen der Verarbeitung',
    purposesText: 'Wir verarbeiten Ihre personenbezogenen Daten zu folgenden Zwecken:',
    purposesList: [
      'zur Bereitstellung unserer Dienstleistungen (Art. 6 Abs. 1 lit. b DSGVO),',
      'zur Erfüllung gesetzlicher Verpflichtungen (Art. 6 Abs. 1 lit. c DSGVO),',
      'zur Wahrung berechtigter Interessen (Art. 6 Abs. 1 lit. f DSGVO),',
      'auf Basis Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). ',
    ],
    recipients: 'Empfänger der Daten',
    recipientsText: 'Ihre Daten werden nur an Dritte weitergegeben, soweit dies zur Vertragserfüllung erforderlich oder gesetzlich vorgeschrieben ist. Dazu zählen: ',
    recipientsList: [
      'IT- und Hosting-Dienstleister,',
      'Zahlungsdienstleister,',
      'Kommunikationsanbieter,',
      'Marketing- und Analysepartner (nur mit Einwilligung).',
    ],
    dataprocessing: 'Auftragsverarbeitung und Datenübermittlung in Drittländer',
    dataprocessingText: 'Recruta schließt mit allen Partnern, die personenbezogene Daten verarbeiten, Auftragsverarbeitungsverträge (AVV) gemäß Art. 28 DSGVO. Bei Übermittlung in Drittländer (z. B. USA, Brasilien) wird stets ein angemessenes Datenschutzniveau sichergestellt, z. B. über EU-Standardvertragsklauseln oder das EU-US Data Privacy Framework.',
    webtrack: 'Cookies und Webtracking',
    webtrackText: 'Wir verwenden notwendige Cookies sowie – nach Einwilligung – Analyse- und Marketing-Cookies (Google Analytics, LinkedIn Insight, Microsoft Ads). Die Verarbeitung erfolgt nur nach ausdrücklicher Zustimmung über unseren Cookie-Banner.',
    storageDuration: 'Speicherdauer',
    storageDurationText: 'Personenbezogene Daten werden gelöscht, sobald sie für die Erreichung des Zweckes nicht mehr erforderlich sind oder gesetzliche Aufbewahrungsfristen abgelaufen sind. ',
    yourRights: 'Ihre Rechte',
    yourRightsText: 'Sie haben das Recht auf:',
    yourRightsList: [
      'Auskunft (Art. 15 DSGVO),',
      'Berichtigung (Art. 16 DSGVO),',
      'Löschung (Art. 17 DSGVO),',
      'Einschränkung (Art. 18 DSGVO),',
      'Datenübertragbarkeit (Art. 20 DSGVO),',
      'Widerruf Ihrer Einwilligung (Art. 7 Abs. 3 DSGVO).',
    ],
    complain: 'Beschwerderecht',
    complainText: 'Sie können sich jederzeit an eine Datenschutzaufsichtsbehörde wenden. Zuständig ist der Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen.',
    security: 'Datensicherheit',
    securityText: 'Wir verwenden aktuelle technische und organisatorische Sicherheitsmaßnahmen (z. B. SSL-Verschlüsselung, Zugriffsbeschränkung, Firewalls), um Ihre Daten gegen Verlust, Zerstörung oder unbefugten Zugriff zu schützen.',
    automation: 'Automatisierte Entscheidungen / Profiling',
    automationText: 'Automatisierte Entscheidungen im Sinne von Art. 22 DSGVO finden nicht statt. Ein Profiling erfolgt ausschließlich pseudonymisiert zur statistischen Auswertung mit Ihrer Einwilligung.',
    changesPrivacy: 'Änderungen dieser Datenschutzerklärung',
    changesPrivacyText: 'Gesetzesänderungen oder technische Entwicklungen können Anpassungen erforderlich machen. Die jeweils aktuelle Fassung finden Sie unter ',
    lastUpdate: 'Letzte Aktualisierung: ',
    lastUpdateDate: 'April 2025',
  },
  career_coaching: {
    title: 'Karriere-Coaching',
    subtitle: 'Fachkundige Beratung für Ihren nächsten Karriereschritt',
    features: {
      feat1: {
        title: 'Persönliche Beurteilung',
        description:
          'Eingehende Analyse von Fähigkeiten, Erfahrungen und Karrierezielen',
      },
      feat2: {
        title: 'Zielsetzung',
        description: 'Entwicklung klarer, realisierbarer Karriereziele',
      },
      feat3: {
        title: 'Einzelsitzungen',
        description:
          'Regelmäßige Coaching-Sitzungen mit erfahrenen Berufsberatern',
      },
      feat4: {
        title: 'Fortschrittskontrolle',
        description:
          'Kontinuierliche Überwachung und Anpassung der Karriereplanung',
      },
    },
    process: 'Unser Coaching-Prozess',
    expect: 'Was Sie erwarten können',
    benefit: 'Vorteile',
    expectations: [
      'Erstbewertung und Zielsetzung',
      'Persönlicher Karriereplan',
      'Regelmäßige Coaching-Sitzungen',
      'Fortschrittskontrolle und Anpassung des Plans',
    ],
    benefits: [
      'Klare berufliche Ausrichtung und Ziele',
      'Verbesserte Selbstwahrnehmung',
      'Verbesserte Strategien für die Arbeitssuche',
      'Gestärktes Selbstbewusstsein',
    ],
  },
  job_placement: {
    title: 'Arbeitsvermittlungsservice',
    subtitle: 'Talente mit Möglichkeiten zusammenbringen',
    success: 'Unsere Erfolgsmetriken',
    placement_rate: 'Vermittlungsquote',
    avarage: 'Durchschnittliche Dauer bis zur Vermittlung',
    days: 'Tage',
    satisfaction: 'Kundenzufriedenheit',
    features: {
      feat1: {
        title: 'Arbeitsmarktanalyse',
        description:
          'Umfassende Analyse der aktuellen Chancen auf dem Arbeitsmarkt',
      },
      feat2: {
        title: 'Gezielte Stellensuche',
        description:
          'Zugang zu exklusiven Stellenangeboten und Arbeitgebernetzwerken',
      },
      feat3: {
        title: 'Vorbereitung auf das Vorstellungsgespräch',
        description:
          'Fachkundige Beratung für erfolgreiche Vorstellungsgespräche',
      },
      feat4: {
        title: 'Gehaltsverhandlung',
        description:
          'Unterstützung bei der Aushandlung wettbewerbsfähiger Vergütungspakete',
      },
    },
  },
  skills_development: {
    title: 'Kompetenzentwicklung',
    subtitle: 'Verbessern Sie Ihre beruflichen Fähigkeiten',
    courses: {
      course1: {
        title: 'Technische Fertigkeiten',
        description: 'Programmierung, Datenanalyse und digitale Werkzeuge',
        topics: ['Web-Entwicklung', 'Datenwissenschaft', 'Cloud Computing'],
      },
      course2: {
        title: 'Soft Skills',
        description: 'Führungsqualitäten, Kommunikation, und Teamarbeit',
        topics: ['Öffentliches Reden', 'Teamleitung', 'Lösung von Konflikten'],
      },
      course3: {
        title: 'Branchenkenntnisse',
        description: 'Branchenspezifische Schulungen und Zertifizierungen',
        topics: [
          'Branchenstandards',
          'Bewährte Praktiken',
          'Einhaltung von Vorschriften',
        ],
      },
    },
    approach: 'Unser Lernkonzept',
    path: 'Personalisierte Lernwege',
    methods: 'Methoden des Wissenserwerbs',
    skills: 'Bewertung der Qualifikationen und Analyse der Schwachstellen',
    plan: 'Entwicklung eines individuellen Lernplans',
    progress: 'Fortschrittskontrolle und Anpassungen',
    online_courses: 'Online-Kurse zum Selbststudium',
    workshops: 'Virtuelle Live-Workshops',
    projects: 'Praktische Projekte',
    mentoring: 'Mentoring durch Branchenexperten',
  },
  imprint: {
    title: 'Impressum',
    subtitle: 'Website Information',
    text1: 'Diese Website wird betrieben von der Recruta GmbH.',
    text2: 'Recruta GmbH ist verantwortlich für sämtliche Inhalte dieser Website, insbesondere für Informationen im Bereich Personalvermittlung, Digitalisierung, Outplacement und Softwareentwicklung.',
    companyData: 'Unternehmensangaben gemäß § 5 TMG',
    company: 'Recruta GmbH',
    addressStreet: 'Von-Vincke-Straße 5–7',
    addressCity: '48143 Münster',
    addressCountry: 'Deutschland',
    phone: 'Telefon: +49 (0) 251 – 74849741',
    email: 'E-Mail:',
    emailAddress: 'info@recruta.net',
    website: 'Website:',
    url: 'www.recruta.net',
    text3: 'Handelsregister: Amtsgericht Münster, HRB 20612\n'
            + 'Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: DE359540773\n'
            + 'Vertreten durch den Geschäftsführer: Gabriel Morais',
    insuranceTitle: 'Berufshaftpflichtversicherung gemäß § 2 Abs. 1 Nr. 11 DL-InfoV',
    insuranceName: 'Versicherer: exali AG',
    insuarnaceText1: 'URL:',
    insuranceUrl: 'www.exali.de',
    insuarnaceText2: 'Geltungsbereich: Deutschland und Mitgliedsstaaten der Europäischen Union',
    authorityTitle: 'Zuständige Aufsichtsbehörde',
    authorityText1: 'Ordnungsamt Münster',
    authorityText2: 'Klemensstraße 10',
    authorityText3: '48143 Münster',
    authorityText4: 'Deutschland',
    disputeTitle: 'Online-Streitbeilegung / Verbraucherstreitbeilegung',
    disputeText1: 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS-Plattform) bereit:',
    disputeUrl: 'https://ec.europa.eu/consumers/odr',
    disputeText2: 'Wir sind weder verpflichtet noch bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',
  },
  chatbot: {
    buttonlabel: 'Chatten Sie mit uns',
    closeLabel: 'Chat Schließen',
    sendLabel: 'Senden',
    welcome:
      'Hallo! Ich bin Benedikt Stein, Ihr persönlicher Outplacement-Berater. Wie kann ich Ihnen heute helfen?',
    title: 'Outplacement-Berater',
    placeholder: 'Schreiben Sie Ihre Nachricht...',
    error:
      'Entschuldigung, aber ich habe Schwierigkeiten, Ihre Anfrage zu verarbeiten. Bitte versuchen Sie es erneut oder kontaktieren Sie unser Support-Team.',
    you: 'Sie',
  },
  scrollToTop: "Nach oben scrollen",
};
